export

const roles = {
  SIS_ADMIN: 'SIS_ADMIN', // user role admin
  RELEVANT_TO_SUBSCRIPTION: 'RELEVANT_TO_SUBSCRIPTION', // relevant to active subscription (with any role)
  SIS_ADMIN_OR_RELEVANT_TO_SUBSCRIPTION: 'SIS_ADMIN_AND_RELEVANT_TO_SUBSCRIPTION',
  SIS_ADMIN_OR_SUBSCRIPTION_ADMIN: 'SIS_ADMIN_OR_SUBSCRIPTION_ADMIN',
  SIS_ADMIN_OR_SUBSCRIPTION_ADMIN_OR_SUBSCRIPTION_OWNER: 'SIS_ADMIN_OR_SUBSCRIPTION_ADMIN_OR_SUBSCRIPTION_OWNER',
};
